import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { AppHeader } from '@components/AppHeader/AppHeader';
import NoResults from '@components/NoResults/NoResults';
import { TripCard } from '@components/TripCard/TripCard';
import { ERoutes } from '@enums/routes.enum';
import useApi from '@hooks/useApi';
import useTripSocket from '@hooks/useTripSocket';
import { setIsRefreshing } from '@store/auth/authSlice';
import type { RootState } from '@store/store';
import type { Trip } from '@store/trips/tripsSlice';

import classes from './Trips.module.scss';

const Trips = () => {
	const trips = useSelector((state: RootState) => state.trips.data);
	const dispatch = useDispatch();

	const socketTripsIds = useMemo(() => trips?.map((trip) => trip.id) || [], [trips]);

	const { getSingleTrip } = useApi();
	useTripSocket(socketTripsIds);
	const navigate = useNavigate();

	const handleOnClick = (tripId: Trip['id']) => {
		dispatch(setIsRefreshing(true));
		getSingleTrip(tripId);
		navigate(`${ERoutes.tripInfo}/${tripId}`);
	};

	return !trips?.length ? (
		<NoResults />
	) : (
		<div className={classes['container']}>
			<AppHeader showBorder />
			<div className={classes['tripsContainer']}>
				{trips.map((trip) => (
					<TripCard
						key={trip.id}
						from={trip.from}
						to={trip.to}
						date={trip.date}
						status={trip.status}
						onClick={() => handleOnClick(trip.id)}
					/>
				))}
			</div>
		</div>
	);
};

export default Trips;
